import React from 'react';
import AppProvider from 'components/AppProvider';
import TopBar from '../../../TopBar';

interface Props {
  username: string;
  logOutUrl: string;
  homeUrl: string;
}

export default function Page(props: Props) {
  return (
    <AppProvider>
      <TopBar {...props} />

      <div className="error-page-content page-content">
        <h2>You are not authorised to view this page.</h2>
      </div>
    </AppProvider>
  );
}
